var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.039,
    height: 107.405,
    viewBox: "0 0 116.039 107.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(0 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13755",
    "data-name": "Path 13755",
    d: "M52.4,31h-.037A21.412,21.412,0,0,0,52.4,73.824h.038A21.412,21.412,0,0,0,52.4,31Zm.035,42.133H52.4a20.721,20.721,0,0,1-.034-41.443H52.4a20.721,20.721,0,0,1,.035,41.443Z",
    transform: "translate(-9.579 -8.815)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13756",
    "data-name": "Path 13756",
    d: "M64.06,50.574a.345.345,0,0,0-.485.057l-11.982,15.2a.345.345,0,1,0,.542.428l11.981-15.2A.345.345,0,0,0,64.06,50.574Zm1.019,6.152-7.027,8.91a.345.345,0,1,0,.542.428l7.027-8.91a.345.345,0,1,0-.542-.428Zm-7-5.8a.344.344,0,0,0-.485.057l-7.022,8.91a.345.345,0,1,0,.542.428l7.022-8.91A.345.345,0,0,0,58.081,50.922Z",
    transform: "translate(-15.619 -14.846)",
    fill: "#d1defd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13757",
    "data-name": "Path 13757",
    d: "M106.534,107.029H97.868a9.055,9.055,0,0,0,1.152-1l2.485-2.548c2.743-2.809,3.267-6.765.059-9.943L76.127,68.35l-2.249,2.307-5.525-5.328A29.008,29.008,0,0,0,44.371,20H44.32a29.01,29.01,0,1,0,.047,58.02h.053a28.861,28.861,0,0,0,16.153-4.946l5.647,5.44L63.71,81.09l25.442,25.186a8.661,8.661,0,0,0,.878.754H12.6a.691.691,0,0,0,0,1.381h93.936a.691.691,0,1,0,0-1.381ZM44.418,76.638h-.05a27.628,27.628,0,1,1-.045-55.257h.049a27.628,27.628,0,1,1,.046,55.257Zm17.305-4.38a29.207,29.207,0,0,0,5.816-5.795l5.375,5.184-5.731,5.876Zm28.4,33.037L65.656,81.072,76.144,70.311l24.448,24.206c2.9,2.871,1.861,6.013-.076,8l-2.486,2.549a5.9,5.9,0,0,1-4.138,1.966,5.322,5.322,0,0,1-3.769-1.735Zm-80.98,1.735H5.691a.691.691,0,0,0,0,1.381H9.144a.691.691,0,0,0,0-1.381Z",
    transform: "translate(-1.546 -5.413)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1593",
    "data-name": "Ellipse 1593",
    cx: 0.691,
    cy: 0.691,
    r: 0.691,
    transform: "translate(0 101.617)",
    fill: "#ebf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13758",
    "data-name": "Path 13758",
    d: "M160.144,146h-3.454a.691.691,0,0,0,0,1.381h3.454a.691.691,0,1,0,0-1.381Z",
    transform: "translate(-48.249 -44.383)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1594",
    "data-name": "Ellipse 1594",
    cx: 0.691,
    cy: 0.691,
    r: 0.691,
    transform: "translate(114.658 101.617)",
    fill: "#ebf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13759",
    "data-name": "Path 13759",
    d: "M108.225,9.407a1.381,1.381,0,1,0,1.381,1.381A1.381,1.381,0,0,0,108.225,9.407Zm0,2.072a.691.691,0,1,1,.691-.691A.691.691,0,0,1,108.225,11.479ZM48.133,6.644a2.072,2.072,0,1,0-2.072-2.072,2.072,2.072,0,0,0,2.072,2.072Zm0-3.108A1.036,1.036,0,1,1,47.1,4.572,1.036,1.036,0,0,1,48.133,3.536ZM110.3,50.85a.691.691,0,1,0-.691-.691.691.691,0,0,0,.691.691Zm0-1.036a.345.345,0,1,1-.345.345A.345.345,0,0,1,110.3,49.814ZM81.978,48.777A1.381,1.381,0,1,0,80.6,47.4a1.381,1.381,0,0,0,1.381,1.381Zm0-2.072a.691.691,0,1,1-.691.691.691.691,0,0,1,.691-.691ZM7.381,10.789A1.381,1.381,0,1,0,6,9.407a1.381,1.381,0,0,0,1.381,1.381Zm0-2.072a.691.691,0,1,1-.691.691.691.691,0,0,1,.691-.691Z",
    transform: "translate(-1.856)",
    fill: "#ebf1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13760",
    "data-name": "Path 13760",
    d: "M84.4,107.105l2-2.017a.346.346,0,1,0-.491-.487l-2.239,2.259a.345.345,0,0,0,0,.485l20.721,21.226a.345.345,0,1,0,.494-.483Zm2.969,30.2H58.361a.691.691,0,0,0,0,1.381H70.793v1.381H63.886a.691.691,0,1,0,0,1.381H82.535a.691.691,0,1,0,0-1.381h-7.6V138.69H87.37a.691.691,0,1,0,0-1.381Zm9.67,0H90.133a.691.691,0,1,0,0,1.381H97.04a.691.691,0,1,0,0-1.381Zm-41.443,0H48.691a.691.691,0,0,0,0,1.381H55.6a.691.691,0,1,0,0-1.381Z",
    transform: "translate(-14.846 -31.547)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13761",
    "data-name": "Path 13761",
    d: "M8.6,68.742l1.027-1.35-.649-.367-.659,1.513H8.293l-.67-1.5-.66.379L7.98,68.731v.021l-1.589-.205v.735l1.6-.205V69.1L6.964,70.417l.616.39.7-1.524H8.3L8.952,70.8l.681-.389L8.6,69.109v-.021l1.631.195v-.735L8.6,68.763Z",
    transform: "translate(-1.977 -19.957)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13762",
    "data-name": "Path 13762",
    d: "M35.713,19.826l.591-.778-.373-.211-.38.871h-.012l-.385-.865-.381.218.586.759v.012l-.915-.118v.423l.921-.118v.012l-.592.759.355.224.4-.877h.012l.373.871.392-.224-.6-.747v-.012l.939.113v-.423l-.939.124Z",
    transform: "translate(-10.653 -5.053)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13763",
    "data-name": "Path 13763",
    d: "M152.315,47.221V46.5l-1.6.212v-.021l1.008-1.325-.636-.361-.646,1.484h-.022l-.657-1.473-.647.372,1,1.293V46.7l-1.558-.2v.72l1.569-.2v.021l-1.007,1.293.6.382.689-1.5h.021l.636,1.484.668-.381-1.017-1.272V47.03Z",
    transform: "translate(-45.946 -13.147)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13764",
    "data-name": "Path 13764",
    d: "M112.1,10.737l-.869,1.115.521.329.6-1.29h.017l.549,1.28.576-.329-.878-1.1v-.019l1.381.165v-.622l-1.381.182v-.018l.869-1.143-.548-.311-.558,1.28h-.018l-.567-1.271-.558.32.86,1.115v.018l-1.345-.173v.622l1.354-.174Z",
    transform: "translate(-34.252 -2.005)",
    fill: "#9dbafc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/emptySearch.b277c04e.svg";
export { ForwardRef as ReactComponent };